import ir3Logo from '@/svg/ir3Logo.svg';
import { getUser, notify, reviveDate } from '@/utils';
import { platformApiRootUrl } from '@/utils/config';
import { fetchEventSource } from '@microsoft/fetch-event-source';
import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';

export function useNotificationStream() {
  const queryClient = useQueryClient();
  const user = getUser();

  useEffect(() => {
    const ctrl = new AbortController();

    fetchEventSource(`${platformApiRootUrl}/sse/user-notifications`, {
      headers: {
        authorization: `Bearer ${user?.access_token}`,
      },
      signal: ctrl.signal,
      onmessage(msg) {
        console.log('Received notification:', msg);

        if (msg.event === 'insert') {
          const notification = JSON.parse(msg.data, reviveDate);

          notify(notification.title, {
            body: notification.message,
            icon: ir3Logo,
            timestamp: Math.floor(notification.time),
          });

          queryClient.invalidateQueries({ queryKey: ['notifications'] });
        }
      },
    });

    return () => {
      ctrl.abort();
    };
  }, [queryClient, user?.access_token]);
}
